export const getters = {
    pagination: state => state.pagination,
    totalPages: state => state.pagination && state.pagination.totalPages || 0,
    pageSize: state => state.pagination && state.pagination.pageSize,
    pageNumber: state => state.pagination && state.pagination.pageNumber || 0,
    totalElements: state => state.pagination && state.pagination.totalElements || 0,
    numberOfElements: state => state.pagination && state.pagination.numberOfElements || 0,
    locations: state => state.locations,
    filters: state => state.filters,
    searchQuery: state => state.searchQuery,
    sortDirection: state => state.sortDirection,
    sortBy: state => state.sortBy,
    modalFilters: state => state.modalFilters,
};


// WEBPACK FOOTER //
// ./src/store/modules/pageOptions/getters.js